import React from 'react';
import { css, keyframes } from 'react-emotion';
import cx from 'classnames';

import { fadeIn, flex, flatWrapper } from 'appStyles';

const wrapper = css`
  ${flatWrapper};
  font-size: 3.2rem;
  padding-top: 4rem;
  padding-left: 1.5rem;
  width: 100%;
  height: 5rem;
  top: 2rem;
  left: 2.4rem;
  color: rgba(10,100,100,1);
`;


const shiftWrapper = css`
  left: 2.5rem;
  top: -2rem;
  transform: scale(.9);
  transition: .5s .6s ease-in;
  cursor: pointer;
  opacity: .6;
  width: 7rem;
  height: 8rem;

  &:hover {
    opacity: 1;
  }

`;

const normalLetter = css`
  transform: translateX(0);
  display: inline-block;
`;

const addedLetter = css`
  opacity: 0;
  animation: ${fadeIn} forwards;
`;

const removedLetter = css`
  display: inline-block;
  animation: ${fadeIn} reverse forwards;
`;

const ring = css`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 3px solid;
  border-color: transparent;
  padding: .4rem;
  width: 4.7rem;
  height: 4.7rem;
  margin-right: -1.3rem;
`;

const displayRing = css`
  border-color: aqua;
  transition: all 2s .2s, transform 1.4s .1s;
  transform: translateX(-4rem) scale(.45);
`;


export default class FancyLogo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cutoff: !props.animate,
    };
  }

  componentDidMount() {
    this.timer = setTimeout(() => this.setState({ cutoff: true }), 2000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const title = 'ppify';

    const random = () => Math.random() * 50000

    const letterBlock = (letter, idx) => (
      <span
        className={cx(normalLetter, !this.state.cutoff && addedLetter, (this.state.cutoff && idx > 0) && removedLetter)}
        style={ this.state.cutoff
          ? {
              animationDuration: `${(title.length-idx) * .1}s`,
              animationDelay: `${(title.length - idx) * .004}s`,
            }
          : {
            animationDuration: `${idx * .07 + .2}s`,
            animationDelay: `${idx * .11 + .5}s`
          }
        }
        key={random()}
      >
        {letter}
      </span>
    );

    return (
      <div className={cx(wrapper, this.state.cutoff && shiftWrapper)}>
        <div className={cx(ring, this.state.cutoff && displayRing)}>
          {letterBlock('A',0)}
        </div>
        {this.props.animate && title.split('').map((letter, idx) => letterBlock(letter, idx + 1))}
      </div>
    );
  }
}
